import { scaleLinear } from 'd3-scale';
import { useMemo } from 'react';
import { timeToCoordinates } from '../../utils/time';
import { Scale } from '../types/scale';
import { getExtent } from '../utils/scale';
import { TypedScaleLinear } from './useScale';

export const useCoordinatesScale = (scale: Scale, frequency: number) => {
  const range = getExtent(scale.range());
  const domain = getExtent(scale.domain());

  return useMemo(
    () =>
      scaleLinear()
        .domain([0, timeToCoordinates(domain, frequency)])
        .range([0, range]),
    [domain, range, frequency],
  ) as TypedScaleLinear<number, number>;
};
